module.exports = __webpack_public_path__ + "static/1234218047-wide.458aa560.jpg";